import {
  LayoutDashboard, Network, Users, Wallet, FileBarChart2, Database, Settings,
  Router, Radio, MapPin, Receipt, TrendingUp, TrendingDown, Banknote, Landmark,
  PiggyBank, Gauge, IdCard, Package, Handshake, Building2, Sliders, UserCheck, Smartphone, DatabaseBackup, FileText, Boxes,
} from "lucide-react";

// Registri lengkap semua menu (top-level + submenu dalam dropdown)
export const MENU = [
  { key: "dashboard", label: "Dashboard", path: "/dashboard", icon: LayoutDashboard, color: "cyan", testid: "nav-dashboard" },
  {
    key: "jaringan", label: "Jaringan", base: "/jaringan", icon: Network, color: "blue", testid: "nav-jaringan-dropdown",
    children: [
      { key: "jaringan_mikrotik", label: "Mikrotik RouterOS", path: "/jaringan/mikrotik", icon: Router, testid: "nav-mikrotik" },
      { key: "jaringan_olt", label: "OLT & Optical ONU", path: "/jaringan/olt", icon: Radio, testid: "nav-olt" },
      { key: "jaringan_maps", label: "Maps & ODP Fiber", path: "/jaringan/maps", icon: MapPin, testid: "nav-maps" },
    ],
  },
  { key: "pelanggan", label: "Data Pelanggan", path: "/pelanggan", icon: Users, color: "emerald", testid: "nav-pelanggan" },
  {
    key: "keuangan", label: "Keuangan", base: "/keuangan", icon: Wallet, color: "amber", testid: "nav-keuangan-dropdown",
    children: [
      { key: "keuangan_tagihan", label: "Data Tagihan", path: "/keuangan/tagihan", icon: Receipt, testid: "nav-tagihan" },
      { key: "keuangan_pendapatan_lain", label: "Pendapatan Lain", path: "/keuangan/pendapatan-lain", icon: TrendingUp, testid: "nav-pendapatan-lain" },
      { key: "keuangan_kas", label: "Kas & Bank", path: "/keuangan/kas", icon: Landmark, testid: "nav-kas" },
      { key: "keuangan_pengeluaran", label: "Pengeluaran", path: "/keuangan/pengeluaran", icon: TrendingDown, testid: "nav-pengeluaran" },
      { key: "keuangan_gaji", label: "Gaji Karyawan", path: "/keuangan/gaji", icon: Banknote, testid: "nav-gaji" },
      { key: "keuangan_pajak", label: "Manajemen Pajak", path: "/keuangan/pajak", icon: Landmark, testid: "nav-pajak" },
      { key: "keuangan_dana_cadangan", label: "Dana Cadangan", path: "/keuangan/dana-cadangan", icon: PiggyBank, testid: "nav-dana-cadangan" },
      { key: "keuangan_operasional", label: "Manajemen Operasional", path: "/keuangan/operasional", icon: Gauge, testid: "nav-operasional" },
      { key: "keuangan_aset", label: "Manajemen Aset Tetap", path: "/keuangan/aset", icon: Boxes, testid: "nav-aset" },
    ],
  },
  { key: "laporan", label: "Laporan", path: "/laporan", icon: FileBarChart2, color: "purple", testid: "nav-laporan" },
  {
    key: "master", label: "Master Data", base: "/master", icon: Database, color: "indigo", testid: "nav-master-dropdown",
    children: [
      { key: "master_karyawan", label: "Data Karyawan", path: "/master/karyawan", icon: IdCard, testid: "nav-master-karyawan" },
      { key: "master_paket", label: "Data Paket", path: "/master/paket", icon: Package, testid: "nav-master-paket" },
      { key: "master_wilayah", label: "Data Wilayah", path: "/master/wilayah", icon: MapPin, testid: "nav-master-wilayah" },
      { key: "master_odp", label: "Data ODP", path: "/master/odp", icon: Radio, testid: "nav-master-odp" },
      { key: "master_mitra", label: "Data Mitra/Investor", path: "/master/mitra", icon: Handshake, testid: "nav-master-mitra" },
      { key: "master_penarik", label: "Data Penarik/Kolektor", path: "/master/penarik", icon: UserCheck, testid: "nav-master-penarik" },
    ],
  },
  {
    key: "pengaturan", label: "Pengaturan", base: "/pengaturan", icon: Settings, color: "teal", testid: "nav-pengaturan-dropdown",
    children: [
      { key: "pengaturan_perusahaan", label: "Pengaturan Perusahaan", path: "/pengaturan/perusahaan", icon: Building2, testid: "nav-pengaturan-perusahaan" },
      { key: "pengaturan_aplikasi", label: "Pengaturan Aplikasi", path: "/pengaturan/aplikasi", icon: Sliders, testid: "nav-pengaturan-aplikasi" },
      { key: "pengaturan_pengguna", label: "Pengaturan Pengguna", path: "/pengaturan/pengguna", icon: UserCheck, testid: "nav-pengaturan-pengguna" },
      { key: "pengaturan_data", label: "Backup & Reset Data", path: "/pengaturan/data", icon: DatabaseBackup, testid: "nav-pengaturan-data" },
      { key: "pengaturan_legal", label: "Halaman Legal", path: "/pengaturan/legal", icon: FileText, testid: "nav-pengaturan-legal" },
      { key: "pengaturan_download_apk", label: "Download APK", path: "/pengaturan/download-apk", icon: Smartphone, testid: "nav-download-apk" },
    ],
  },
];

export const BUILTIN_ROLES = [
  { id: "admin", label: "Super Admin", desc: "Akses penuh — tidak dapat dibatasi", locked: true },
  { id: "finance", label: "Finance / Kasir", desc: "Fokus penagihan & keuangan" },
  { id: "teknisi", label: "Teknisi Lapangan", desc: "Fokus jaringan & instalasi" },
  { id: "investor", label: "Investor / Mitra", desc: "Akses terbatas: dashboard, bagi hasil & laporan" },
  { id: "penarik", label: "Penarik / Kolektor", desc: "Tagih ke rumah pelanggan per wilayah" },
];

// Semua key modul (untuk matrix akses & default)
export const allModuleKeys = () => {
  const keys = [];
  MENU.forEach((m) => { keys.push(m.key); (m.children || []).forEach((c) => keys.push(c.key)); });
  return keys;
};

const isPengaturanKey = (key) => key === "pengaturan" || key.startsWith("pengaturan_");

export const isVisible = (key, visibility) => !visibility || visibility[key] !== false;

export const isAllowed = (key, role, roleAccess) => {
  if (role === "admin") return true;
  const scope = roleAccess ? roleAccess[role] : undefined;
  if (!scope) return true; // belum dikonfigurasi => tampilkan semua
  return scope.includes(key);
};

// Aturan tampil: admin selalu bisa akses Pengaturan (anti-lockout)
export const canShow = (key, { visibility, role, roleAccess }) => {
  // Backup & Reset Data + Halaman Legal: KHUSUS Owner / Super Admin (role admin).
  if (key === "pengaturan_data" || key === "pengaturan_legal") return role === "admin";
  if (role === "admin" && isPengaturanKey(key)) return true;
  if (!isVisible(key, visibility)) return false;
  return isAllowed(key, role, roleAccess);
};
